/** 下单页面-将错就错的写着...麻了麻了 **/
<template>
  <div style="width: 1200px; margin: 30px auto">
    <div class="wholeBox" v-loading="loading">
      <!-- row1 -->
      <div class="infoBox">
        <span
          >收货地址
          <el-divider direction="vertical"></el-divider>
          大型商品下单后，收货地址将无法修改。</span
        >
        <span class="textRedColor"
          >快递公司会电话联系您确认送货时间，收货时需核对身份证信息。</span
        >
      </div>
      <!-- row2 -->
      <div class="getaddressList">
        <div class="getaddressItem isActive">
          <el-col :span="18">
            寄送至：
            <span v-if="defaultAddress != ''">
              <strong>地址: </strong> {{ defaultAddress.areaName }} &nbsp;
              <span>{{ defaultAddress.address }}</span>
              （<strong>姓名: </strong> {{ defaultAddress.recipient }}收）

              <strong>电话: </strong> {{ defaultAddress.phoneNumber }}
            </span>
            <span v-else>请先添加地址</span>
          </el-col>
          <el-col :span="6" class="address_right">
            <span class="defaultAddressColor" v-show="defaultAddress != ''"
              >默认地址</span
            >
            <span
              @click="editAddress(defaultAddress, 1)"
              class="edit"
              v-show="defaultAddress != ''"
              >修改</span
            >
            <span
              @click="editAddress(defaultAddress, 0)"
              class="edit"
              v-show="defaultAddress == ''"
              >添加</span
            >
          </el-col>
        </div>
      </div>
      <!-- row3 -->

      <el-row>
        <el-col :span="6">
          <el-button class="footerbtn addbtn" @click="openStore"
            >添加商品</el-button
          >
        </el-col>
        <el-col :offset="11" :span="5">
          <div class="grid-content bg-purple">
            <el-input
              placeholder="请输入商城订单号"
              v-model="orderNumberRelated"
              v-show="isShowOrederId"
              clearable
            >
            </el-input>
          </div>
        </el-col>
        <el-col :span="2" class="row_3_right">
          <el-switch
            v-model="isopenOrderId"
            active-color="#13ce66"
            inactive-color="#c0c4cc"
            @change="showInput"
          >
          </el-switch>
          <el-tooltip
            class="item"
            effect="dark"
            content="开启绑定商城订单"
            placement="top-end"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-col>
        <!-- <el-link class="row_3_right" type="danger" @click="setOrderId" :underline="false">绑定商城订单</el-link> -->
      </el-row>
      <!-- row4 -->
      <div>
        <div class="main" v-if="flage">
          <el-row class="titlet">
            <el-col :span="4"  v-if="typedata==1">商品</el-col>
            <el-col :span="10" v-if="typedata!=1">商品</el-col>
            <el-col :span="6" v-if="typedata==1">交货日期要求</el-col>
            <el-col :span="5">单价</el-col>
            <el-col :span="5">数量</el-col>
            <el-col :span="2">小计</el-col>
            <el-col :span="2"
              ><div class="grid-content bg-purple-light">操作</div></el-col
            >
          </el-row>
          <el-row
            v-for="(item, index) in orderInfoList"
            :key="index"
            class="itemlists"
          >
            <el-col :span="4" v-if="typedata==1">
              <div class="itemtop">
                <el-image
                  :src="'http://xyss.com.cn/no.png'"
                  fit="fill"
                  style="width: 100px; heigth: 100px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="name">
                  <p>{{ item.purchaseOrderDetails.productName }}</p>
                  <p style="color: #909399">
                    规格:{{ item.purchaseOrderDetails.spec }}
                  </p>
                </div>
              </div>
            </el-col>
            <el-col :span="10" v-if="typedata!=1">
              <div class="itemtop">
                <el-image
                  :src="'http://xyss.com.cn/no.png'"
                  fit="fill"
                  style="width: 100px; heigth: 100px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="name">
                  <p>{{ item.purchaseOrderDetails.projectName || '--' }}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6" style="margin-top:10px" v-if="typedata==1">{{item.purchaseOrderDetails.deliverDays}}</el-col>
            <el-col :span="5">
              <p>￥{{ item.amount }}</p>
            </el-col>
            <el-col :span="5" class="deteleBtn">
              <el-input-number
                v-model="item.purchaseOrderDetails.number"
                @change="handleNumChange()"
                :min="1"
                label="数量"
              ></el-input-number>
            </el-col>
            <el-col :span="2">
              <p>
                <span
                  >￥{{
                    item.purchaseOrderDetails.quoteAmountTotal == null
                      ? (
                          item.purchaseOrderDetails.number * item.amount
                        ).toFixed(2)
                      : item.purchaseOrderDetails.quoteAmountTotal
                  }}</span
                >
              </p>
            </el-col>
            <el-col :span="2" class="deteleBtn">
              <el-button type="danger" size="mini" @click="onDelete(item.id)"
                >删除</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- row汇总底部 -->
    <div class="bottom" v-if="flage">
      <p>
        应付总金额:<span class="total">￥{{ amountTotal.toFixed(2) }}</span>元
      </p>
    </div>
    <!-- 最底部合计 -->
    <div class="bottomCount">
      <div class="isFixed">
        <div class="isfixeditems">
          <div class="grid-content totalNum">
            <p>
         合计:<strong class="totalSize"
              >￥{{ amountTotal.toFixed(2) }}</strong
            >元
            </p>
           
          </div>
          <div class="grid-content">
            <el-button
              class="countedSize"
              type="danger"
              @click="submitForm()"
              :disabled="!(amountTotal > 0)"
              >生成订单</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框部分 -->
    <!-- 商品的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="beforeClose"
      width="750px"
      class="dialogBox"
    >
      <div class="dialogtop">
        <div class="main-flag">
          <b></b>
          <span>选择商品</span>
        </div>
        <div class="search">
          <el-input
            v-model="title"
            placeholder="请输入产品名称"
            class="ipt"
            @keyup.enter.native="handleSearch()"
          ></el-input>
          <button class="btn" @click="handleSearch()">查询</button>
        </div>
      </div>
      <div class="dialogmain">
        <div class="noData" v-if="datalist.length == 0">没有相关商品!</div>
        <div v-for="(item, index) in datalist" :key="index">
          <div class="items">
            <el-checkbox
              v-model="item.checked"
              @change="handleCheckedGoodsChange"
              style="margin-top: 40px"
            ></el-checkbox>
            <div class="checkbottom">
              <el-image
                :src="'http://xyss.com.cn/no.png'"
                fit="fill"
                style="width: 100px; heigth: 100px; margin: 10px 10px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="items-right" v-if="typedata==1">
                <p class="title" >
                  {{
                    item.purchaseOrderDetails.productName == null
                      ? "-- "
                      : item.purchaseOrderDetails.productName
                  }}
                </p>
                <p class="content">
                  <span>规格：{{
                      item.purchaseOrderDetails.spec == null
                        ? "-- "
                        : item.purchaseOrderDetails.spec
                    }}</span>
                  <span>交货日期：{{
                      item.purchaseOrderDetails.deliverDays == null
                        ? "-- "
                        : item.purchaseOrderDetails.deliverDays
                    }}</span>
                  <span>技术参数：{{
                      item.purchaseOrderDetails.technicalRqmts == null
                        ? "-- "
                        : item.purchaseOrderDetails.technicalRqmts
                    }}</span>
                  <span>单位：{{
                      item.purchaseOrderDetails.unit == null
                        ? "-- "
                        : item.purchaseOrderDetails.unit
                    }}</span>
                </p>
                <p class="price">￥{{ item.amount }}</p>
              </div>
              <div class="items-right" v-if="typedata!=1">
                <p class="title" >
                  {{
                    item.purchaseOrderDetails.projectName == null
                      ? "-- "
                      : item.purchaseOrderDetails.projectName
                  }}
                </p>
                <p class="price">￥{{ item.amount }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="end">
        <el-checkbox
          :indeterminate="indeterminate"
          v-model="ischeckAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <el-button class="addbtn footerbtn" @click="handleConfirm"
          >确 认</el-button
        >
        <el-button @click="dialogVisible = false" class="footercancelbtn"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 地址的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      :destroy-on-close="true"
      :title="isaddoredit == 0 ? '新增地址' : '修改地址'"
      :close-on-click-modal="false"
      @close="beforeClose"
      width="30%"
      class="dialogBox"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="收件人" prop="recipient">
          <el-input
            type="text"
            v-model="ruleForm.recipient"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
            type="text"
            v-model="ruleForm.phoneNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <!-- 添加地址时展示 -->
        <el-form-item
          label="地址"
          prop="areaid"
          v-show="showEditButtom ? false : true"
        >
          <el-cascader
            v-model="cascaderAreaValue"
            ref="cascaderAddr"
            class="cascaderArea"
            placeholder="请选择收货地址"
            :props="{ checkStrictly: true }"
            :options="getprovince"
            @change="areaHandleChange"
          >
          </el-cascader>
        </el-form-item>
        <!-- 修改地址时展示 -->
        <el-form-item
          label="地址"
          prop="areaid"
          v-show="showEditButtom ? true : false"
        >
          <div class="addressCss" v-if="areaName">
            <span>{{ areaName }}</span
            ><span class="editCss" @click="isShowAddress">修改地址</span>
          </div>
          <!-- <el-input type="text" v-model="ruleForm.areaid" autocomplete="off"></el-input> -->
          <el-cascader
            v-else
            v-model="cascaderAreaValue"
            ref="cascaderAddr"
            class="cascaderArea"
            placeholder="请选择收货地址"
            :props="{ checkStrictly: true }"
            :options="getprovince"
            @change="areaHandleChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="postalCode">
          <el-input v-model="ruleForm.postalCode"></el-input>
        </el-form-item>
        <el-form-item prop="">
          <el-checkbox v-if="isaddoredit" v-model="ruleForm.defaultAddress"
            >默认地址</el-checkbox
          >
          <el-checkbox v-else   v-model="checkeds" disabled>默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="comfiremdisabled"
          @click="submintAddress()"
          class="buttonBgd"
          >{{ isaddoredit == 0 ? "保存" : "确定修改" }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 生成订单弹框 -->
    <!-- <el-dialog :visible.sync="centerDialogVisible" width="25%" center>
      <div><i class="el-icon-warning-outline centericon"></i></div>
      <span class="order">订单已生成,请等待供应商确认</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="addbtn" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  commodityList,
  addresslist,
  address_add,
  address_remove,
  address_saveedit,
  addOrder,
  area_list,
  getSpecificationselect,
  order,
  getStoreFreight,
  coveragePrice,
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      typedata:'',
      purchaseId: "", //选中采购单ID
      addressLists: [],
      defaultAddress: "", //默认地址
      dialogVisible2: false, //地址弹框
      showEditButtom: false,
      isaddoredit: 0, //默认是新增
      cascaderAreaValue: [],
      ruleForm: {
        muid: JSON.parse(localStorage.getItem("userdata")).userId,
        recipient: "",
        phoneNumber: "",
        areaid: "",
        address: "",
        postalCode: "",
        defaultAddress: 1,
      },
      comfiremdisabled: false, //防止重复
      rules: {
        recipient: [
          {
            required: true,
            message: "收件人，不能为空",
            trigger: ["blur", "change"],
          },
        ],
        phoneNumber: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value == "") {
                callback(new Error("不能为空,请输入"));
              } else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
                callback(new Error("请输入11位正确格式的手机号"));
              } else {
                callback();
              }
            },
          },
        ],
        areaid: [
          {
            required: true,
            message: "地址，不能为空",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "详细地址，不能为空",
            trigger: ["blur", "change"],
          },
        ],
        postalCode: [
          {
            required: true,
            message: "编码，不能为空",
            trigger: ["blur", "change"],
          },
        ],
        headerName: [
          {
            required: true,
            trigger: ["blur"],
            validator: (rule, value, callback) => {
              if (this.groupType == 1 && value == "") {
                callback(new Error("不能为空,请输入"));
              } else if (this.groupType == 2 && value == "") {
                callback(new Error("不能为空,请输入"));
              } else {
                callback();
              }
            },
          },
        ],
        taxNumber: [
          {
            required: true,
            trigger: ["blur"],
            validator: (rule, value, callback) => {
              if (this.groupType == 2 && value == "") {
                callback(new Error("不能为空,请输入"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      datalist: [], //商品列表
      dialogVisible: false, //商品弹框开关
      ischeckAll: false, //多选状态值
      indeterminate: false, //多选不确定状态
      flage: false, //商品清单开关
      orderInfoList: [],
      amountTotal: 0.0, //合计总价
      orderlist: [],
      title: "",
      isopenOrderId: false, //是否开始绑定外部订单
      orderNumberRelated: "", //外部订单号
      isShowOrederId: false, //是否显示外部订单号入口
      info: "",
      // -------------------------------------------------------------------------------------------------------
      centerDialogVisible: false,
      num: "",
      checked: '',
      checkeds:true,
      textarea: "",
      textarea2: "",
      taxpayerNumber: "",
      Gropu: 1,
      type: 1,
      visible: false,
      activityType: "", // 接受积分的活动状态
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      isSelectedAddress: "",
      loading: false,

      selected: false,
      openradio: 1,
      invoiceType: 1, //是否是电子发票
      groupType: 1, // 个人还是单位的
      formLabelAlign: {
        // 发票里填写的内容
        invoiceTitle: "",
        taxpayerNumber: "",
        registerAddress: "",
        tel: "",
        bank: "",
        address: "",
        bankAccount: "",
        invoiceName: "",
        invoiceTel: "",
        invoiceAddressDetail: "",
      },
      invoiceAddressValue: [], //收票人地址
      seeMoreCommonProblem: false, // 更多常见问题弹框

      redPackmoney: "",
      showpopover: "",
      envelopeList: [], // 我领取过的红包
      // getprovince:[], // 地址联动

      selectedOrderList: JSON.parse(sessionStorage.getItem("selectList")) || [],
      scidArr: [],
      numberTotal: 0,
      orderTitle: "",
      moneyTotal: 0, // 应付总额
      priceList: [], // 各个店铺总金额
      payMethodsCheckbox: 1, // 支付方式 在线支付/货到付款
      shopGoodsObj: [], // 店铺及其商品对应的集合
      selectedAddressId: "", // 选择的收货地址id
      addressitemObj: {}, // 选中的地址对象
      storeFreightList: [], // 店铺运费
      activityPriceReq: 0, // 店铺活动优惠
      memberPriceReq: 0, // 店铺会员折扣
      buyNow: false, // 是否是从立即购买按钮跳转过来的
      areaName: "",

      isDisabled: false,
    };
  },
  // 注册组件
  components: {},
  computed: {
    ...mapState(["getprovince"]),
  },

  created() {},
  mounted() {
    this.getaddresslist();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 重置地址默认
    resetAddress() {
      this.ruleForm = {
        muid: JSON.parse(localStorage.getItem("userdata")).userId,
        recipient: "",
        phoneNumber: "",
        areaid: "",
        address: "",
        postalCode: "",
        defaultAddress: 1,
      };
    },
    // 地址查询 bingo
    getaddresslist() {
      this.loading = true;
      addresslist({
        muid: this.userInfo.userId,
      }).then((res) => {

        if (res.code == 0) {
          // console.log("Diz ");
          this.loading = false;
          this.defaultAddress = "";
          if (res.rows.length > 0) {
            this.addressLists = res.rows;
            if (this.addressLists.length > 0) {
              // console.log(111);
              this.addressLists.forEach((item, index) => {
                if (item) {
                  this.defaultAddress = item;
                  this.selectedAddressId = item.said;
                }
              });
            } else {
              this.selectedAddressId = "";
            }
          }
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    // 跳转到修改地址页面
    // type:0-新增;1-编辑
    editAddress(item, type) {
      console.log(item, "设置修改预制");
      this.dialogVisible2 = true;
      this.showEditButtom = true;
      this.isaddoredit = type;
      if (type == 1) {
        //修改预制
        this.areaName = item.areaName;
        this.ruleForm = {
          muid: item.muid,
          said: item.said,
          recipient: item.recipient,
          phoneNumber: item.phoneNumber,
          areaid: item.areaid,
          address: item.address,
          postalCode: item.postalCode,
          defaultAddress: item.defaultAddress == 1 ? true : false,
        };
      } else {
        this.cascaderAreaValue = [];
      }
    },

    // 新增默认收货地址|修改默认收货地址
    submintAddress() {
      if (this.isaddoredit == "1") {
        // console.log("to edit");
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let editReq = {
              muid: this.ruleForm.muid,
              said: this.ruleForm.said,
              recipient: this.ruleForm.recipient,
              phoneNumber: this.ruleForm.phoneNumber,
              areaid: this.ruleForm.areaid,
              address: this.ruleForm.address,
              postalCode: this.ruleForm.postalCode,
              defaultAddress: this.ruleForm.defaultAddress ? 1 : 0,
            };
            address_saveedit(editReq)
              .then((res) => {
                if (res.code == 0) {
                  this.showEditButtom = false;
                  this.dialogVisible2 = false;
                  this.resetAddress();
                  this.cascaderAreaValue = [];
                  this.getaddresslist();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.dialogVisible2 = false;
                this.$message.error("修改失败，请稍后再试！");
              });
          }
        });
      } else {
        console.log("to add");
        this.$refs.ruleForm.validate((valid) => {
          (this.ruleForm.muid = this.userInfo.userId),
            (this.ruleForm.defaultAddress = this.ruleForm.defaultAddress
              ? 1
              : 0);
          if (valid) {
            this.comfiremdisabled = true;
            address_add(this.ruleForm)
              .then((res) => {
                if (res.code == 0) {
                  this.dialogVisible2 = false;
                  this.comfiremdisabled = false;
                  this.resetAddress();
                  this.getaddresslist();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                  this.comfiremdisabled = false;
                }
              })
              .catch((err) => {
                this.dialogVisible = false;
                this.$message.error("提交失败，请稍后再试！");
              });
          }
        });
      }
    },
    //打开商品列表
    openStore() {
      this.dialogVisible = true;
      this.title = "";
      commodityList({
        purchaseOrderId: this.$route.query.id,
      }).then((res) => {
        if (res.code == 0) {
          this.typedata=res.data.type
          this.datalist = res.data.quoteDetails;
          // if (this.typedata != 1) {
          //   this.datalist = this.datalist.map((val) => {
          //     val.purchaseOrderDetails.number = val.purchaseOrderDetails.quantities
          //     return val
          //   })
          // }
          this.ischeckAll = false;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    //搜索
    handleSearch() {
      commodityList({
        purchaseOrderId: this.$route.query.id,
        productName: this.title,
      }).then((res) => {
        if (res.code == 0) {
          this.datalist = res.data;
          // if (this.typedata != 1) {
          //   this.datalist = this.datalist.map((val) => {
          //     val.purchaseOrderDetails.number = val.purchaseOrderDetails.quantities
          //     return val
          //   })
          // }
          this.ischeckAll = false;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    //全选按钮触发
    handleCheckAllChange(e) {
      //一级change事件
     
      this.ischeckAll = e;
      this.indeterminate = false;
      this.datalist.forEach((item) => {
        item.checked = e;
      });
    },
    // 选中单个商品多选框事件
    handleCheckedGoodsChange(e) {
      // 多选change事件
   
      let count = 0;
      // debugger
      this.datalist.forEach((item) => {
        if (item.checked) {
          count++;
        }
      });
      if (this.datalist.length == count) {
        this.indeterminate = false;
        this.ischeckAll = true;
      } else if (this.datalist.length > count && count > 0) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
        this.ischeckAll = false;
      }
    },
    //商品确定
    handleConfirm() {
      // console.log(this.datalist, "其中checked=true选中;data");
      this.datalist.forEach((item) => {
        if (item.checked) {      
          var countItem = this.orderInfoList.filter((t) => t.id == item.id);
          if (countItem.length) {
            // console.log(countItem, "这个商品已经添加过！！！");
            countItem[0].purchaseOrderDetails.number =
              countItem[0].purchaseOrderDetails.number + 1;
          } else {
            item.purchaseOrderDetails.number = 1;
            this.orderInfoList.push(item);
          }
        }
      });
      this.$forceUpdate();
      //合计一个总额
      this.totalAmount();
      console.log(this.datalist, "订单预计列表！！！");
      this.flage = true;
      this.dialogVisible = false;
    },
    //合计总额
    totalAmount() {
      this.amountTotal = 0.0;
      this.orderInfoList.forEach((item) => {
        this.amountTotal += item.purchaseOrderDetails.number * item.amount;
      });
    },
    //生成订单
    submitForm() {
      // console.log(this.orderInfoList, "下单啦");
      this.orderlist = [];
      this.orderInfoList.forEach((item) => {
        return this.orderlist.push({
          quoteInfoDetailsId: item.id,
          number: item.purchaseOrderDetails.number,
        });
      });
      if (this.defaultAddress.said == undefined) {
        this.$message.info("请填写地址");
      } else {
        let obj = {
          userId: JSON.parse(localStorage.getItem("userdata")).userId,
          mid: JSON.parse(localStorage.getItem("userdata")).bxmId,
          purchaseOrderId: Number(this.$route.query.id),
          said: Number(this.defaultAddress.said),
          orderNumberRelated: this.orderNumberRelated,
          detailsList: this.orderlist,
        };

        order(obj).then((res) => {
          // console.log(res.code, "code");
          if (res.code === 0) {
            this.centerDialogVisible = true;
            this.$router.push(`/mypurchaseRight`);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },

    //显示外部订单
    showInput() {
      this.isShowOrederId = !this.isShowOrederId;
      this.orderNumberRelated = "";
    },
    //删除确定
    onDelete(id) {
      // debugger;
      this.orderInfoList.splice(
        this.orderInfoList.findIndex((item) => item.id == id),
        1
      );
      this.totalAmount();
    },
    // 改变数量 实时计算
    handleNumChange() {
      this.totalAmount();
      // this.$store.commit('getCartList',this.list)
    },
    // ----------------------------------------------------------------------------------------------------------------------------------------------

    handleChange() {},
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },

    isShowAddress() {
      this.areaName = "";
    },

    getSpecification(id) {
      let nameArr = [];
      getSpecificationselect({
        specificationId: id || 0,
      })
        .then((res) => {
          if (res.code == 0) {
            res.rows.forEach((item) => {
              nameArr.push(item.bXyAttributeList[0].name);
            });
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试！");
        });
      return nameArr;
    },

    //   选择收货地址
    selectedAddress(index, selectedAddressId, itemObj) {
      this.addressitemObj = itemObj;
      this.selected = true;
      this.isSelectedAddress = index;
      this.selectedAddressId = selectedAddressId;
      let storesList = [];
      this.shopGoodsObj.forEach((item) => {
        let goodsList = [];
        item.goodsList.forEach((goodsItem) => {
          let goods = {};
          if (!goodsItem.activity) {
            // 只查主商品的运费
            goods = {
              id: goodsItem.id,
              number: goodsItem.number,
              specId: goodsItem.bxysid,
            };
            goodsList.push(goods);
          }
        });
        let obj = {};
        obj = {
          bxmId: item.bxmId,
          goodsList: goodsList,
        };
        storesList.push(obj);
      });
      const req = {
        said: this.selectedAddressId, // 收货地址
        storesList: storesList, // 店铺信息
      };

      if (this.selectedAddressId) {
        // 调修改运费接口
        getStoreFreight(req)
          .then((res) => {
            if (res.data.code == 0) {
              this.storeFreightList = res.data.data;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message.error("查询运费失败，请稍后再试！");
          });
      }
    },
    // 填写地址选择
    areaHandleChange(value) {
      // debugger;
      this.$refs["cascaderAddr"].getCheckedNodes();
      this.ruleForm.areaid = value[value.length - 1];
    },

    // 添加地址
    addAddress() {
      this.dialogVisible = true;
    },
    //   关闭弹框清空
    beforeClose() {
      this.ruleForm = {};
      this.cascaderAreaValue = [];
      this.showEditButtom = false;
    },

    //   删除地址
    deleteAddress(deleteId) {
      address_remove({
        ids: deleteId,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "地址删除成功",
            });
            this.getaddresslist();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
//地址栏
.defaultAddressColor {
  color: gray;
}
.address_right {
  text-align: right;
}
.edit {
  margin-left: 30px;
  color: #c65442;
}

.items {
  border-bottom: 1px solid #eee;
  padding: 10px;
  display: flex;
  justify-content: start;
  .checkbottom {
    padding: 10px;
    display: flex;
    justify-content: start;
    // border-bottom: 1px solid #eee;
    .items-right {
      margin-left: 10px;
      height: 38px;
      line-height: 38px;
      .price {
        color: red;
      }
      .title {
        font-weight: bold;
        color: #000;
      }
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          margin-right: 40px;
          color: gray;
        }
      }
    }
  }
}
.noData {
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.main {
  padding: 20px;
  .titlet {
    color: gray;
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee !important;
  }
  .itemlists {
    font-size: 16px;
    border-bottom: 1px dashed #eee;
    margin: 10px 5px;
    // padding-top: 10px;
    p {
      margin-top: 15px;
      font-size: 15px;
      span {
        color: red;
      }
    }
    .itemtop {
      display: flex;
      .name {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
//中间合计
.bottom {
  font-size: 18px;
  margin: 20px 0;
  padding: 10px 0;
  border: 1px solid #fbb68c;
  background-color: #fff7f1;
  margin-bottom: 50px !important;
  .amount {
    padding-left: 1000px;
    border-bottom: 1px solid #fbb68c;
  }
  .total {
   
    margin-left: 15px;
  }
  p {
    padding: 10px;
    height: 60px;
    line-height: 60px;
    text-align: end;
    span {
       font-weight: bold;
      color: red;
    }
  }
}
/deep/.el-button--danger {
    color: #FFF;
    background-color: #c65442;
    border-color: #c65442;
}
//合计页尾
.bottomCount {
  margin-bottom: -50px;
  .isFixed {
    position: fixed;
    bottom: 0;
  
    width: 1200px;
    margin: auto;
    background-color: #fff;
    z-index: 1;
    margin-bottom: 20px;
    .isfixeditems {
    float: right;
      display: flex;
      flex-flow: row nowrap;
    
    }
  }
  .countedSize {
    background-color: #c65442;
    border:#c65442 ;
    width: 180px;
  
    margin-left: 20px;
  }
 
   
 .totalNum {
   
     p{
       color: #000;
    .totalSize {
      font-size: 30px;
       color: red;
    }
    }
  }
  
 
}
// row3
.row_3_right {
  line-height: 38px;
  text-align: end;
}
.item {
  font-size: 18px;
  line-height: 18px;
  align-items: center;
  position: relative;
  /* font-size: 14px; */
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
  color: #c0c4cc;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.deteleBtn {
  line-height: 50px;
}
// -------------------------------------------------------------------------------
.centericon {
  display: flex;
  height: 30px;
  justify-content: center;
  color: #c65442;
  font-size: 24px;
  font-weight: bold;
}

.order {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.search_box {
  text-align: right;
  margin-bottom: 10px;
  .input-with-select.el-input.el-input-group.el-input-group--append {
    width: 40%;
  }
}

.nave_table {
  margin: 15px 0;
  .nave_table_top {
    font-size: 14px;
    padding: 5px 0px;
    border: 1px solid gray;
    border-bottom: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #eef1f6;
    p {
      padding: 0 20px;
      color: gray;
      span {
        margin: 0 10px;
        color: #000;
      }
    }
  }
  .nave_table_bottom {
    font-size: 14px;
    padding: 10px 10px;
    padding-bottom: 0;
    border: 1px solid gray;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top {
      display: flex;
    }
    .list {
      display: flex;
      flex-direction: column;
      p {
        height: 30px;
      }
      .Details {
        cursor: pointer;
      }
    }
    .last {
      margin-right: 30px;
      color: gray;
      cursor: pointer;
    }
  }
}

.end {
  width: 80%;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footerbtn {
  width: 200px;
  border-bottom: 1px solid #c65442;
}

.footercancelbtn {
  width: 200px;
  background-color: #fff;
  color: #c65442;
  border: 1px solid #c65442;
}

.dialogtop {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  .main-flag {
    margin-bottom: 20px; // margin-left: 20px;
    b {
      display: inline-block;
      width: 3px;
      height: 18px;
      background: #c6523f;
      vertical-align: middle;
    }
    span {
      font-weight: bold;
      font-size: 18px;
      padding-left: 8px;
      vertical-align: middle;
    }
  }
  .search {
    display: flex;
    .ipt {
      outline: none;
    }
    .btn {
      color: white;
      font-size: 14px;
      border: none;
      border-radius: 0 4px 4px 0;
      width: 80px;
      height: 40px;
      line-height: 20px;
      background-color: #c65442;
      padding: 10px;
    }
  }
}

.addbtn {
  background-color: #c65442;
  color: white;
}

.wholeBox {
  padding: 30px;
  background: white;
  .isActive {
    border: 1px solid #c65442 !important;
    background: #f1f6fd;
  }
  .infoBox {
    .textRedColor {
      color: #c65442;
    }
  }
  .getaddressList {
    width: 1240px;
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    .addHover {
      padding: 63px 30px !important;
    }
    .addHover:hover {
      cursor: pointer;
      color: #ff6700;
    }
    .getaddressItem {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: start;
      border: 1px solid #c65442;
      display: inline-block;
      padding: 10px;
      width: 90%;
      cursor: pointer;
      margin-bottom: 10px;
      height: 30px;
      line-height: 30px;
      background-color: #fcebe9;
      .addressColor {
        text-align: right;
        position: relative;
        bottom: -20px;
        color: #ff6700;
        cursor: pointer;
        font-size: 14px;
        span {
          display: inline-block;
          margin-left: 15px;
        }
        .delete {
          /deep/button.el-button.el-button--default.el-popover__reference {
            border: 0px;
            color: #ff6700;
            padding: 0;
          }
          /deep/.el-button:focus,
          .el-button:hover {
            background: transparent;
          }
        }
      }
    }
  }
}

.cascaderArea.el-cascader {
  width: 100%;
  /deep/input[disabled],
  /deep/input[disabled="disabled"],
  /deep/input[readonly],
  /deep/input[readonly="readonly"] {
    background-color: white;
  }
}

.addressCss {
  display: flex;
  justify-content: space-between;
  .editCss {
    color: #c65442;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/procurementOrder/index.vue